import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import TransactionalNewController from './controller';
import TransactionalMessageModel from 'cio/models/transactional-message';
import FeaturesService from 'ember-feature-flags/services/features';
import DS from 'ember-data';
import isDestroyed from 'cio/utils/is-destroyed';
import AuthService from 'cio/services/auth';
import RouterService from '@ember/routing/router-service';

export default class TransactionalMessagesNew extends Route {
  @service features!: FeaturesService;
  @service store!: DS.Store;
  @service auth!: AuthService;
  @service router!: RouterService;

  crumb() {
    return {
      name: 'New',
      path: 'transactional.new',
    };
  }

  beforeModel(transition: Transition) {
    super.beforeModel(transition);
    if (Boolean(this.auth.hasPermission('journeys/transactional_messages/create')) === false) {
      this.router.transitionTo('transactional.index');
    }
    return;
  }

  model() {
    return this.store.createRecord('transactional-message');
  }

  resetController(controller: TransactionalNewController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      let model = this.modelFor(this.routeName) as TransactionalMessageModel;
      if (!isDestroyed(model)) {
        model.rollbackAttributes();
      }
    }
  }
}
